var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.51614,
    cy: 8.51614,
    r: 8.51614,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51614 0C3.82047 0 0 3.82047 0 8.51614C0 13.2118 3.82047 17.0323 8.51614 17.0323C13.2118 17.0323 17.0323 13.2118 17.0323 8.51614C17.0323 3.82047 13.2118 0 8.51614 0ZM12.5305 6.54302L7.94491 11.7837C7.76541 11.9881 7.50993 12.11 7.23741 12.1191C7.22693 12.1191 7.21514 12.1191 7.20466 12.1191C6.94393 12.1191 6.69369 12.0156 6.51026 11.8309L3.88991 9.21054C3.50603 8.82666 3.50603 8.20432 3.88991 7.82044C4.27379 7.43656 4.89613 7.43656 5.28001 7.82044L7.15749 9.69792L11.0513 5.24857C11.409 4.83979 12.03 4.79786 12.4375 5.15554C12.8476 5.51322 12.8882 6.13424 12.5305 6.54302Z",
    fill: "#00E59E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.0bc639c3.svg";
export { ForwardRef as ReactComponent };